import { Grid2, Skeleton } from "@mui/material";

const TabSkeleton = ({ height, width, count, borderRadius, gap, rowGap }) => {
  return (
    <Grid2
      container
      direction="row"
      justifyContent="flex-start"
      sx={{
        flex: "1 1 1",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: gap || "1.6vw",
        rowGap: rowGap || "1.6vw",
      }}
    >
      {Array?.from(new Array(count))?.map((_, index) => (
        <Grid2 item key={index}>
          <Skeleton
            variant="rectangular"
            width={width}
            height={height}
            sx={{
              borderRadius: borderRadius || ".25vw",
            }}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default TabSkeleton;